import React from 'react';

const ResultsPhase = ({
  score,
  terms,
  masteryAnswers,
  nextLessonLoading = false,
  nextLessonUnavailable = false,
  nextLessonError = '',
  onReviewTerm,
  onGoToNextLesson,
  onDoneNavigate,
  onRetakeMastery,
  showRoomExplore = false,
  onRoomExplore,
}) => {
  const percentage = score.total > 0 ? Math.round((score.correct / score.total) * 100) : 0;

  return (
    <div className="lcv-results-panel">
      <div className="lcv-results-score">{percentage}%</div>
      <div className="lcv-results-label">
        {score.passed ? 'Mastery Achieved!' : 'Keep Practicing!'}
      </div>
      <div className="lcv-results-detail">
        You got {score.correct} out of {score.total} questions correct.
        {score.passed
          ? ' Great work — you\'ve demonstrated mastery of this lesson!'
          : ` You need ${Math.round(score.threshold * 100)}% to pass. Review the terms below and try again.`}
      </div>

      <div className="lcv-results-breakdown">
        {terms.map((t, i) => {
          const answer = masteryAnswers.find(a => a.questionIndex === i);
          const passed = answer?.correct ?? false;
          return (
            <div key={i} className="lcv-result-row">
              <span className={`lcv-result-icon ${passed ? 'lcv-ri-pass' : 'lcv-ri-miss'}`}>
                {passed ? '✓' : '✗'}
              </span>
              <span className="lcv-result-term">{t.term}</span>
              {passed ? (
                <span className="lcv-result-status lcv-rs-pass">Passed</span>
              ) : (
                <button
                  type="button"
                  className="lcv-result-status-btn lcv-rs-miss"
                  onClick={() => onReviewTerm?.(i)}
                >
                  Review
                </button>
              )}
            </div>
          );
        })}
      </div>

      <div className="lcv-results-actions">
        <button
          type="button"
          className="lcv-btn-secondary lcv-results-action-btn"
          onClick={onRetakeMastery}
        >
          Retake Mastery Test
        </button>
        {showRoomExplore && typeof onRoomExplore === 'function' && (
          <button
            type="button"
            className="lcv-btn-secondary lcv-results-action-btn lcv-results-explore-btn"
            onClick={onRoomExplore}
          >
            Explore
          </button>
        )}
        <button
          type="button"
          className="lcv-btn-primary lcv-results-action-btn"
          onClick={onGoToNextLesson}
          disabled={nextLessonLoading || nextLessonUnavailable}
        >
          {nextLessonLoading
            ? 'Loading Next Lesson...'
            : nextLessonUnavailable
              ? 'No More Lessons'
              : 'Go To Next Lesson'}
        </button>
      </div>

      {nextLessonUnavailable && (
        <div className="lcv-results-popup" role="status" aria-live="polite">
          <div className="lcv-results-popup-text">
            You're all done with available lessons.
          </div>
          <button
            type="button"
            className="lcv-results-popup-link"
            onClick={onDoneNavigate}
          >
            Click here to go back to the dashboard
          </button>
        </div>
      )}

      {nextLessonError && <div className="lcv-results-error">{nextLessonError}</div>}
    </div>
  );
};

export default ResultsPhase;
